/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createReducer, on } from '@ngrx/store';
import * as AppInsightsActions from './app-insights.actions';
import { IAppInsightsState, initialState } from './app-insights.state';

export const appInsightsReducer = createReducer(
    initialState,

    on(
        AppInsightsActions.loadAppInsights,
        (state: IAppInsightsState): IAppInsightsState => ({
            ...state,
            loading: true,
            error: null,
        }),
    ),

    on(
        AppInsightsActions.loadAppInsightsSuccess,
        (state: IAppInsightsState, { vsId, data, lastUpdatedTimestamp }): IAppInsightsState => ({
            ...state,
            appInsightsByVs: {
                ...state.appInsightsByVs,
                [vsId]: {
                    appInsights: data,
                    lastUpdatedTimestamp,
                    initialLoaded: true,
                },
            },
            loading: false,
        }),
    ),
);
